import { Kevel } from './kevel.js?v=2.4';
import { ViewItemListEvent } from './view-item-list-event.js';
import SponsorProductDrawer from './sponsored-product-drawer.js';
import SponsoredSlideFooter from './sponsored-display-footer.js';

const newProductGridCard = {
  getCardSize: function () {
    const cardProduct = document.querySelector('#product-grid .card-product:not(.card-kevel)');
    if (cardProduct !== null) {
      return {
        width: cardProduct.getBoundingClientRect().width,
        height: cardProduct.getBoundingClientRect().height,
      };
    }
    return null;
  },
};

async function getProductById(handle) {
  return await fetch(`/products/${handle}.js`)
    .then((response) => response.json())
    .catch((err) => console.error(`Product handle "${handle}" not found!`));
}

const STOREFRONT_DOMAIN = 'farmaciasdirect-eu.myshopify.com';
const STOREFRONT_API_VERSION = '2025-10';
const STOREFRONT_ACCESS_TOKEN = '8084a6622e40fb7f6caa45eec5f0e699';

const GET_VARIANTS_BADGES = `
  query GetProductWithVariantBadges($handle: String!) {
    product(handle: $handle) {
      id
      variants(first: 50) {
        nodes {
          id
          markets: metafield(namespace: "farmaciasdirect", key: "markets_badges") {
            value
          }
          badges: metafield(namespace: "farmaciasdirect", key: "badges") {
            references(first: 20) {
              nodes {
                ... on Metaobject {
                  id
                  name: field(key: "name") { value }
                  label: field(key: "label") { value }
                  position: field(key: "position") { value }
                  fg_color: field(key: "fg_color") { value }
                  gb_color: field(key: "gb_color") { value }
                  icon: field(key: "icon") {
                    reference {
                      ... on MediaImage {
                        image {
                          url
                          width
                          height
                          altText
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

let storefrontClientInstance = null;

async function getVariantsBadgesByProductHandle(handle) {
  const client = getStorefrontClient();
  if (!client) return null;

  try {
    const response = await client.request(GET_VARIANTS_BADGES, {
      variables: { handle },
      headers: {
        'Accept-Language': Shopify.locale
      }
    });

    return response?.data?.product ?? null;
  } catch (error) {
    console.error("Error fetching product with variant badges", error);
    return null;
  }
}

function getStorefrontClient() {
  if (storefrontClientInstance) {
    return storefrontClientInstance;
  }

  if (typeof ShopifyStorefrontAPIClient === 'undefined') {
    console.error('Sponsored post: ShopifyStorefrontAPIClient is not available');
    return null;
  }

  storefrontClientInstance = ShopifyStorefrontAPIClient.createStorefrontApiClient({
    storeDomain: STOREFRONT_DOMAIN,
    apiVersion: STOREFRONT_API_VERSION,
    publicAccessToken: STOREFRONT_ACCESS_TOKEN
  });

  return storefrontClientInstance;
}

function onSubmitHandler(evt, campaign) {
  evt.preventDefault();
  InterfaceX.addProductToCart();
  const form = evt.srcElement;
  let error = false;
  const cartNotification = document.querySelector('cart-notification');
  const cartDrawer = document.querySelector('cart-drawer');

  const qtyInput = form.querySelector('.quantity__input');
  let qty = 1;
  if (qtyInput && qtyInput.value) qty = qtyInput.value;

  const submitBtn = form.querySelector('.card-product__actions--btn');
  submitBtn.ariaDisabled = true;
  submitBtn.classList.add('loading');
  submitBtn.querySelector('.loading__spinner').classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  let formData = new FormData(form);
  if (cartNotification || cartDrawer) {
    const cartNotificationSections = cartNotification.getSectionsToRender().map((section) => section.id);
    const cartDrawerSections = cartDrawer.getSectionsToRender().map((section) => section.id);

    formData.append('sections', [...cartNotificationSections, ...cartDrawerSections]);
    formData.append('sections_url', window.location.pathname);
    formData.append('properties[_added_at]', new Date().toISOString());
    cartNotification.setActiveElement(document.activeElement);
  }

  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((data) => {
      if (data.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: data.errors || data.description,
          message: data.message,
        });

        submitBtn.ariaDisabled = true;
        submitBtn.querySelector('span').classList.add('hidden');
        error = true;
      } else if (!cartNotification && !cartDrawer) {
        window.location.href = routes.cart_url;
        return;
      }

      if (!error) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: data,
        });
        manageProductAddToCart(data.handle, qty, '');
      }

      cartNotification.renderContents(data);
    })
    .catch((error) => console.error(error))
    .finally(() => {
      submitBtn.classList.remove('loading');
      if (cartNotification && cartNotification.classList.contains('is-empty'))
        cartNotification.classList.remove('is-empty');
      if (cartDrawer && cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
      if (!error) submitBtn.removeAttribute('aria-disabled');
      submitBtn.querySelector('.loading__spinner').classList.add('hidden');
    });
    
  fetch(`${campaign.clickUrl}&noredirect`);
  fdKevel.sendAddToCartEvent(campaign);
}

const productGrid = document.getElementById('product-grid');
const categories = productGrid?.dataset.categories ? JSON.parse(productGrid.dataset.categories): [];

const fdKevel = new Kevel();
fdKevel
  .setDivName('product-grid')
  .setParent('ProductGridContainer')
  .load(
    [
      {
        divName: 'brand-corner',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [329745],
        adTypes: [11421, 163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
          ...(categories.length > 0 
          ? {
            ctcategories: {
              in: categories,
              nullValuesMatch: true
            }
          } 
          : {}),
        },
        eventIds: [40, 60],
      },
      {
        divName: 'product-grid-3',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [329742],
        adTypes: [163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
          ...(categories.length > 0 
          ? {
            ctcategories: {
              in: categories,
              nullValuesMatch: false
            }
          } 
          : {}),
        },
        eventIds: [40, 60],
      },
      {
        divName: 'product-grid-7',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [335451],
        adTypes: [163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
          ...(categories.length > 0 
          ? {
            ctcategories: {
              in: categories,
              nullValuesMatch: false
            }
          } 
          : {}),
        },
        eventIds: [40, 60],
      },
      {
        divName: 'product-grid-9',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [333723],
        adTypes: [163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
          ...(categories.length > 0 
          ? {
            ctcategories: {
              in: categories,
              nullValuesMatch: false
            }
          } 
          : {}),
        },
        eventIds: [40, 60],
      },
      {
        divName: 'product-grid-11',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [335452],
        adTypes: [163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
          ...(categories.length > 0 
          ? {
            ctcategories: {
              in: categories,
              nullValuesMatch: false
            }
          } 
          : {}),
        },
        eventIds: [40, 60],
      },
      {
        divName: 'product-grid-15',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [333720],
        adTypes: [163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
          ...(categories.length > 0 
          ? {
            ctcategories: {
              in: categories,
              nullValuesMatch: false
            }
          } 
          : {}),
        },
        eventIds: [40, 60],
      },
      {
        divName: 'product-grid-17',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [333721],
        adTypes: [163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
          ...(categories.length > 0 
          ? {
            ctcategories: {
              in: categories,
              nullValuesMatch: false
            }
          } 
          : {}),
        },
        eventIds: [40, 60],
      },
      {
        divName: 'product-grid-19',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [335453],
        adTypes: [163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
          ...(categories.length > 0 
          ? {
            ctcategories: {
              in: categories,
              nullValuesMatch: false
            }
          } 
          : {}),
        },
        eventIds: [40, 60],
      },
      {
        divName: 'product-grid-21',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [335454],
        adTypes: [163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
          ...(categories.length > 0 
          ? {
            ctcategories: {
              in: categories,
              nullValuesMatch: false
            }
          } 
          : {}),
        },
        eventIds: [40, 60],
      },
      {
        divName: 'product-grid-28',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [335455],
        adTypes: [163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
          ...(categories.length > 0 
          ? {
            ctcategories: {
              in: categories,
              nullValuesMatch: false
            }
          } 
          : {}),
        },
        eventIds: [40, 60],
      },
      {
        divName: 'product-grid-30',
        networkId: 11757,
        siteId: 1303012,
        zoneIds: [333722],
        adTypes: [163],
        count: 1,
        adQuery: {
          ctavailability: {
            eq: 'in_stock',
            nullValuesMatch: true,
          },
          ...(categories.length > 0 
          ? {
            ctcategories: {
              in: categories,
              nullValuesMatch: false
            }
          } 
          : {}),
        },
        eventIds: [40, 60],
      },
    ],
    [`page=${window.location.pathname}`]
  )
  .onSuccess((ev) => {
    const data = ev.detail;

    if (data.decisions['brand-corner'] != null) {
      const campaign = data.decisions['brand-corner'][0];
      const campaignContent = data.decisions['brand-corner'][0].contents[0];
      const cardProductSize = newProductGridCard.getCardSize();
      const width = cardProductSize ? cardProductSize.width : campaignContent.data.width;
      const height = cardProductSize ? cardProductSize.height : campaignContent.data.height;
      const card = document.querySelector('#product-grid .card-kevel');

      if (card !== undefined && campaignContent.data.ctproduct_handle !== undefined) {
        createSponsoredProductCard(campaign, campaignContent, 0, card, width, height);
      } else {
        createBrandCornerCard(campaign, campaignContent, card, width, height);
      }

      fetch(campaign.impressionUrl);
    }

    document.querySelectorAll('#product-grid .card-kevel').forEach((card) => {
      const productCard = data.decisions[`product-grid-${card.parentNode.dataset.position}`];
      if (productCard == null || productCard === undefined) return;

      productCard.forEach((campaign) => {
        const campaignContent = campaign.contents[0];
        const cardProductSize = newProductGridCard.getCardSize();
        const width = cardProductSize ? cardProductSize.width : campaignContent.data.width;
        const height = cardProductSize ? cardProductSize.height : campaignContent.data.height;

        if (card !== undefined && campaignContent.data.ctproduct_handle !== undefined) {
          createSponsoredProductCard(campaign, campaignContent, card.parentNode.dataset.position, card, width, height);
          fetch(campaign.impressionUrl);
        }
      });
    });
  })
  .onComplete(() => {
    setTimeout(() => {
      const productGrid = document.getElementById('product-grid');
      if (!productGrid) return;

      productGrid.querySelectorAll('.card-kevel').forEach((item) => {
        if (!item.classList.contains('kevel-loaded')) {
          const parent = item.parentElement;
          if (!parent) return;
          parent.classList.add('kevel-slot-empty');
        }
      });

      fillEmptySponsoredSlots(productGrid).then(() => {
        rebuildGridWithSponsorPositions(productGrid);
      });
    }, 1000);
  })
  .onReload();

function renderBadge(badge, targetContainer) {
  if (!badge) return;

  // Si no hay ni label ni icono, no tiene sentido pintar el badge
  if (!badge.label && !badge.icon) return;

  const el = document.createElement('span');
  el.classList.add('card-product__badge', 'badge');

  // Aplicar estilos personalizados de los metacampos
  if (badge.gb_color) el.style.backgroundColor = badge.gb_color;
  if (badge.fg_color) el.style.color = badge.fg_color;

  // Icono (lo ponemos antes del label si existe)
  if (badge.icon) {
    const iconImg = document.createElement('img');
    iconImg.src = badge.icon;
    iconImg.width = 20;
    iconImg.height = 20;
    iconImg.alt = badge.label || badge.name || 'badge icon';
    iconImg.classList.add('card-product__badge-icon');
    el.appendChild(iconImg);
  }

  // Label
  if (badge.label) {
    const labelSpan = document.createElement('span');
    labelSpan.classList.add('card-product__badge-label');
    labelSpan.style.fontSize = '1.2rem';
    labelSpan.textContent = badge.label;
    el.appendChild(labelSpan);
  }

  targetContainer.appendChild(el);
}

async function createSponsoredProductCard(campaign, campaignContent, index, card, width, height) {
  let viewItemListEvent = new ViewItemListEvent();
  const product = await getProductById(campaignContent.data.ctproduct_handle);
  const variantsBadgesByProductHandle = await getVariantsBadgesByProductHandle(campaignContent.data.ctproduct_handle);

  if (product === null || product === undefined) return;

  const variantBadges = variantsBadgesByProductHandle.variants?.nodes?.map(v => {
    let marketsData = {};
    try {
      marketsData = v.markets?.value ? JSON.parse(v.markets.value) : {};
    } catch (e) {
      console.warn("Error parsing markets_badges JSON", e);
    }

    const badgeNodes = v.badges?.references?.nodes || [];

    return {
      variantId: v.id,
      marketAssignments: marketsData,
      badges: badgeNodes.map(b => ({
        id: b.id,
        name: b.name?.value ?? null,
        label: b.label?.value ?? null,
        position: b.position?.value ?? null,
        fg_color: b.fg_color?.value ?? null,
        gb_color: b.gb_color?.value ?? null,
        icon: b.icon?.reference?.image?.url ?? null,
        isAvailableInCurrentMarket: marketsData[b.id]?.includes(window.ShopifyCustom?.currentMarketId) || false
      }))
    };
  });

  card.dataset.jsonProduct = `{"id": ${product.id}, "handle": "${product.handle}", "media": [${product.media
    .map((media) => `{"${media.id}": {"src": "${media.src}", "width": ${media.width}, "height": ${media.height}}`)
    .join('}, ')}}], "title": "${product.title}", "variants": [${product.variants
    .map(
      (variant) =>
        `{"id": ${variant.id}, "title": "${variant.title}", "price": "${variant.price}", "compare_at_price": "${variant.compare_at_price}"}`
    )
    .join(', ')}], "vendor": "${product.vendor}", "type": "${product.type}", "tags": [${product.tags
    .map((tag) => `"${tag}"`)
    .join(', ')}], "featured_image": "${product.featured_image}", "created_at": "${product.created_at}"}`;
  card.dataset.bannerPromo = 'banner';
  card.dataset.bannerId = campaign.flightId || 'none';
  card.dataset.bannerName = campaignContent.data.ctcampaignName || 'none';
  card.dataset.creativeSlot = campaignContent.data.ctcreativeSlot || 'none';
  card.dataset.itemId = campaignContent.data.ctid || 'none';
  card.dataset.bannerIndex = index || campaign.flightId;
  card.dataset.bannerImg = product.featured_image;

  viewItemListEvent.setData(card.dataset.jsonProduct, campaign);
  const cardMediaWrapper = document.createElement('div');
  cardMediaWrapper.classList.add('card-product__image-wrapper');
  const cardMedia = document.createElement('div');
  cardMedia.classList.add('card-product__media');
  cardMediaWrapper.dataset.bannerPromo = 'banner';
  cardMediaWrapper.dataset.bannerId = campaign.flightId || 'none';
  cardMediaWrapper.dataset.bannerName = campaignContent.data.ctcampaignName || 'none';
  cardMediaWrapper.dataset.creativeSlot = campaignContent.data.ctcreativeSlot || 'none';
  cardMediaWrapper.dataset.itemId = campaignContent.data.ctid || 'none';
  cardMediaWrapper.dataset.bannerIndex = index || campaign.flightId;
  cardMediaWrapper.dataset.bannerImg = product.featured_image;

  if (product.media != null) {
    const link = document.createElement('a');
    link.href = product.url;
    link.addEventListener('click', function () {
      fetch(`${campaign.clickUrl}&noredirect`);
    });
    const principalImage = document.createElement('img');
    principalImage.classList.add('card-product__media--image', 'card-product__media--principal');
    principalImage.loading = 'lazy';
    principalImage.alt = product.media[0].alt;
    principalImage.src = product.media[0].src;
    principalImage.width = product.media[0].width;
    principalImage.height = product.media[0].height;
    link.appendChild(principalImage);

    if (product.media[1] != null) {
      const setSizes = [165, 360, 533, 720, 940, 1066];
      const srcSet = [];
      const secondImage = document.createElement('img');
      secondImage.classList.add('card-product__media--image', 'card-product__media--secondary');
      secondImage.loading = 'lazy';
      secondImage.src = `${product.media[1].src}&width=533`;
      secondImage.width = product.media[1].width;
      secondImage.height = product.media[1].height;
      secondImage.sizes =
        '(min-width: 1600px) 367px, (min-width: 1025px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)';
      secondImage.alt = product.media[1].alt;

      setSizes.forEach((size) => {
        if (product.media[1].width >= size) {
          srcSet.push(`${product.media[1].src}&width=${size} ${size}w`);
        }
      });
      secondImage.srcset = srcSet.join(', ');
      link.appendChild(secondImage);
    }

    cardMedia.appendChild(link);
  }

  // ---------------------------------------------
  // BADGES
  // ---------------------------------------------

  // Crear los contenedores de posición
  const badgesTopLeft = document.createElement('div');
  badgesTopLeft.classList.add('card-product__badges', 'top', 'left');

  const badgesTopRight = document.createElement('div');
  badgesTopRight.classList.add('card-product__badges', 'top', 'right');

  const badgesBottomLeft = document.createElement('div');
  badgesBottomLeft.classList.add('card-product__badges', 'bottom', 'left');

  const badgesBottomRight = document.createElement('div');
  badgesBottomRight.classList.add('card-product__badges', 'bottom', 'right');

  const seenBadgeNames = new Set();
  const promotedProductBadge = document.createElement('div');
  promotedProductBadge.classList.add('card-product__badges', 'bottom', 'left');

  // ---------------------------------------------
  // 1) BADGE DE DESCUENTO (solo top_left)
  // ---------------------------------------------

  if (product.compare_at_price > product.price) {
    const discountBadge = document.createElement('span');
    const discount = Math.round((product.compare_at_price - product.price) * 100 / product.compare_at_price);
    discountBadge.classList.add('card-product__badge', 'badge', 'color-scheme-b0e6e809-0af7-4286-8565-6812f1481b32');
    discountBadge.textContent = `-${discount}%`;
    badgesTopLeft.appendChild(discountBadge);
  }

  // ---------------------------------------------
  // 2) BADGES DE VARIANTES (metafields farmaciasdirect.badges)
  // ---------------------------------------------
  variantBadges.forEach(v => {
    (v.badges || []).forEach(badge => {

      if (!badge.isAvailableInCurrentMarket) return;

      const name = badge.name?.trim();
      if (!name) return;

      // evitar duplicados por nombre
      if (seenBadgeNames.has(name)) return;
      seenBadgeNames.add(name);

      // pintar según posición
      switch (badge.position) {
        case 'top_left':
          renderBadge(badge, badgesTopLeft);
          break;

        case 'top_right':
          renderBadge(badge, badgesTopRight);
          break;

        case 'bottom_left':
          renderBadge(badge, badgesBottomLeft);
          break;

        case 'bottom_right':
          renderBadge(badge, badgesBottomRight);
          break;
      }
    });
  });

  cardMedia.appendChild(badgesTopLeft);
  cardMedia.appendChild(badgesTopRight);
  cardMedia.appendChild(badgesBottomLeft);
  cardMedia.appendChild(badgesBottomRight);
  cardMediaWrapper.appendChild(cardMedia);

  const cardContent = document.createElement('div');
  cardContent.classList.add('card-product__content');

  const promotedBadge = document.createElement('span');
  promotedBadge.classList.add('card-product__badge', 'badge', 'promoted');
  promotedBadge.style.backgroundColor = 'transparent';
  promotedBadge.style.fontSize = '10px';
  promotedBadge.style.cursor = 'pointer';
  promotedBadge.style.color = '#1E1A49';
  promotedBadge.style.padding = '0px';
  promotedBadge.style.lineHeight = '0px';
  const infoIcon = `
      <svg xmlns="http://www.w3.org/2000/svg" style="margin-left: .25em;" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-info-icon lucide-info"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
    `;
  promotedBadge.innerHTML = `Promoted ${infoIcon}`;
  promotedBadge.dataset.advertiserName = campaignContent.data.ctadvertiserName || 'Anonymous';
  promotedBadge.dataset.paidForBy = campaignContent.data.ctpaidForBy || 'Anonymous';
  promotedProductBadge.appendChild(promotedBadge);

  promotedBadge.addEventListener('click', function (e) {
    const isMobile = window.innerWidth < 768;
    const position = isMobile ? 'bottom' : 'right';
    const size = isMobile ? 'xs' : 'sm';

    const drawer = new SponsorProductDrawer(position, size);
    drawer.open(this.dataset.advertiserName, this.dataset.paidForBy, { position, size });
  });

  const cardProductName = document.createElement('h3');
  cardProductName.classList.add('card-product__name');
  const cardProductNameLink = document.createElement('a');
  cardProductNameLink.href = product.url;
  cardProductNameLink.classList.add('card-product__name--link');
  cardProductNameLink.innerText = product.title;
  cardProductNameLink.addEventListener('click', function () {
    fetch(`${campaign.clickUrl}&noredirect`);
  });
  cardProductName.appendChild(cardProductNameLink);
  cardContent.appendChild(promotedBadge);
  cardContent.appendChild(cardProductName);

  if (product.vendor) {
    const vendor = product.vendor.toLowerCase();
    const cardProductVendor = document.createElement('div');
    cardProductVendor.classList.add('card-product__info');
    const cardProductVendorLink = document.createElement('a');
    cardProductVendorLink.href = `/collections/${vendor}`;
    cardProductVendorLink.classList.add('card-product__vendor');
    cardProductVendorLink.innerText = String(vendor).charAt(0).toUpperCase() + String(vendor).slice(1);
    cardProductVendor.appendChild(cardProductVendorLink);
    cardContent.appendChild(cardProductVendor);
  }

  // Tags lentillas
  if (product.tags.length > 0) {
    product.tags.forEach((tag) => {
      if (tag === 'Progresivas' || tag === 'Progressivas' || tag === 'Astigmatismo') {
        const lentillasTag = document.createElement('div');
        lentillasTag.classList.add('card-product__lentillas-info', `lentillas-tag-${product.id}`);

        if (tag === 'Progresivas' || tag === 'Progressivas') {
          const progressiveTag = document.createElement('span');
          progressiveTag.style.color = '#df6d0a';
          progressiveTag.innerText = tag;
          lentillasTag.appendChild(progressiveTag);
        }

        if (tag === 'Astigmatismo') {
          const astigmatismTag = document.createElement('span');
          astigmatismTag.style.color = '#77bc1f';
          astigmatismTag.innerText = tag;
          lentillasTag.appendChild(astigmatismTag);
        }

        cardContent.appendChild(lentillasTag);
      }
    });
  }

  // Trusted Shops
  const trustedShopsStars = document.createElement('div');
  trustedShopsStars.innerHTML = `<etrusted-widget
    data-etrusted-widget-id="wdg-cc6cfd6e-2243-40bd-a5bd-0378453342bb"
    data-sku="${product.variants[0].sku}"
  ></etrusted-widget>`;
  cardContent.appendChild(trustedShopsStars);

  // Price
  const cardProductPrice = document.createElement('div');
  cardProductPrice.classList.add('price', 'card-product__price', 'price--on-sale');
  const cardProductPriceContainer = document.createElement('div');
  cardProductPriceContainer.classList.add('price__container');
  const cardProductPriceSale = document.createElement('div');
  cardProductPriceSale.classList.add('price__sale');
  const cardProductPriceItemSale = document.createElement('span');
  cardProductPriceItemSale.classList.add('price-item', 'price-item--sale');
  cardProductPriceItemSale.innerText = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(
    product.price / 100
  );
  cardProductPriceSale.appendChild(cardProductPriceItemSale);

  const cardProductPriceItemRegular = document.createElement('span');
  cardProductPriceItemRegular.classList.add('price-item', 'price-item--regular');
  cardProductPriceItemRegular.innerText = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(
    product.compare_at_price / 100
  );
  cardProductPriceSale.appendChild(cardProductPriceItemRegular);

  cardProductPriceContainer.appendChild(cardProductPriceSale);
  cardProductPrice.appendChild(cardProductPriceContainer);
  cardContent.appendChild(cardProductPrice);

  // Button action
  const cardProductActions = document.createElement('div');
  cardProductActions.classList.add('card-product__actions');

  const cardProductQuickAdd = document.createElement('div');
  cardProductQuickAdd.classList.add('quick-add', 'no-js-hidden');

  const productForm = document.createElement('div');
  const form = document.createElement('form');
  form.method = 'post';
  form.action = '/cart/add';
  form.id = 'product_form_id';
  form.acceptCharset = 'UTF-8';
  form.classList.add('form');
  form.enctype = 'multipart/form-data';
  form.noValidate = 'novalidate';
  form.dataset.type = 'add-to-cart-form';
  const inputFormType = document.createElement('input');
  inputFormType.type = 'hidden';
  inputFormType.name = 'form_type';
  inputFormType.value = 'product';
  const inputUtf = document.createElement('input');
  inputUtf.type = 'hidden';
  inputUtf.name = 'utf8';
  inputUtf.value = '✓';
  const inputVariantId = document.createElement('input');
  inputVariantId.type = 'hidden';
  inputVariantId.name = 'id';
  inputVariantId.value = product.variants[0].id;
  inputVariantId.classList.add('product-variant-id');
  const inputProductId = document.createElement('input');
  inputProductId.type = 'hidden';
  inputProductId.name = 'product-id';
  inputProductId.value = product.id;

  form.appendChild(inputFormType);
  form.appendChild(inputUtf);
  form.appendChild(inputVariantId);

  const buttonAddToCart = document.createElement('button');
  buttonAddToCart.type = 'submit';
  buttonAddToCart.name = 'add';
  buttonAddToCart.classList.add('card-product__actions--btn', 'quick-add__submit', 'button');
  buttonAddToCart.ariaHasPopup = 'dialog';
  buttonAddToCart.ariaLive = 'polite';

  const cartIcon = document.createElement('div');
  cartIcon.classList.add('icon-cart-css');
  cartIcon.style.display = 'block';
  cartIcon.style.padding = '12px';
  buttonAddToCart.appendChild(cartIcon);

  const addToCartText = document.createElement('span');
  addToCartText.innerText = 'Añadir';
  buttonAddToCart.appendChild(addToCartText);

  const spinnerStylesheet = document.createElement('link');
  spinnerStylesheet.rel = 'stylesheet';
  spinnerStylesheet.href = '/cdn/shop/t/20/assets/component-loading-spinner.css';
  spinnerStylesheet.type = 'text/css';
  spinnerStylesheet.media = 'all';
  buttonAddToCart.appendChild(spinnerStylesheet);

  const spinnerDiv = document.createElement('div');
  spinnerDiv.classList.add('loading__spinner', 'hidden');
  spinnerDiv.innerHTML = `
    <svg
      aria-hidden="true"
      focusable="false"
      class="spinner"
      viewBox="0 0 66 66"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
    </svg>
    `;
  buttonAddToCart.appendChild(spinnerDiv);

  form.appendChild(buttonAddToCart);
  form.appendChild(inputProductId);
  form.addEventListener('submit', (e) => onSubmitHandler(e, campaign));
  productForm.appendChild(form);
  cardProductQuickAdd.appendChild(productForm);
  cardProductActions.appendChild(cardProductQuickAdd);
  cardContent.appendChild(cardProductActions);

  card.textContent = '';
  card.appendChild(cardMediaWrapper);
  card.appendChild(cardContent);
  card.style.minWidth = `${width}px`;
  card.style.minHeight = `${height}px`;
  card.classList.add('kevel-image-banner');
  card.classList.add('kevel-loaded');
  card.classList.remove('animated');

  fdKevel.sendViewableImpression(card, campaign);
}

function fillEmptySponsoredSlots(grid) {
  if (!grid) return Promise.resolve();

  const emptySlots = Array.from(grid.querySelectorAll('.kevel-slot-empty')).filter(
    (slot) => slot.dataset.removing !== 'true'
  );

  if (emptySlots.length === 0) return Promise.resolve();

  const duration = 260;

  return new Promise((resolve) => {
    let pending = emptySlots.length;

    emptySlots.forEach((slot) => {
      slot.dataset.removing = 'true';
      const { height } = slot.getBoundingClientRect();
      slot.style.overflow = 'hidden';
      slot.style.maxHeight = `${height}px`;
      slot.style.opacity = '1';
      slot.style.transform = 'scale(1)';
      slot.style.transition = `max-height ${duration}ms ease, opacity ${duration}ms ease, transform ${duration}ms ease`;

      requestAnimationFrame(() => {
        slot.style.maxHeight = '0px';
        slot.style.opacity = '0';
        slot.style.paddingTop = '0px';
        slot.style.paddingBottom = '0px';
        slot.style.marginTop = '0px';
        slot.style.marginBottom = '0px';
        slot.style.transform = 'scale(0.97)';
      });

      setTimeout(() => {
        slot.remove();
        pending -= 1;
        if (pending === 0) resolve();
      }, duration + 60);
    });
  });
}

function rebuildGridWithSponsorPositions(grid) {
  if (!grid) return;

  const loadedItems = Array.from(grid.querySelectorAll('.card-kevel.kevel-loaded'))
    .map((card) => {
      const parent = card.parentElement;
      if (!parent) return null;
      const position = parseInt(parent.dataset.position, 10);
      if (!Number.isFinite(position)) return null;
      return { node: parent, position };
    })
    .filter(Boolean)
    .sort((a, b) => a.position - b.position);

  const sponsorMap = new Map();
  loadedItems.forEach(({ node, position }) => {
    sponsorMap.set(position, node);
  });

  const staticNodes = [];
  const productNodes = Array.from(grid.children)
    .filter((item) => {
      const parentPosition = parseInt(item.dataset.position, 10);
      if (sponsorMap.has(parentPosition)) return false;
      const sponsorCard = item.querySelector('.card-kevel');
      if (sponsorCard && sponsorCard.classList.contains('kevel-loaded')) return false;
      if (!item.dataset.originalIndex) {
        staticNodes.push(item);
        return false;
      }
      return true;
    })
    .sort((a, b) => {
      const indexA = parseInt(a.dataset.originalIndex, 10);
      const indexB = parseInt(b.dataset.originalIndex, 10);
      if (!Number.isFinite(indexA) && !Number.isFinite(indexB)) return 0;
      if (!Number.isFinite(indexA)) return 1;
      if (!Number.isFinite(indexB)) return -1;
      return indexA - indexB;
    });

  const maxSponsorPosition = sponsorMap.size > 0 ? Math.max(...sponsorMap.keys()) : 0;
  const totalSlots = Math.max(productNodes.length + loadedItems.length, maxSponsorPosition);
  const fragment = document.createDocumentFragment();

  staticNodes.forEach((node) => fragment.appendChild(node));

  const productQueue = [...productNodes];

  for (let slot = 1; slot <= totalSlots; slot += 1) {
    const sponsorNode = sponsorMap.get(slot);
    if (sponsorNode) {
      fragment.appendChild(sponsorNode);
      continue;
    }

    const productNode = productQueue.shift();
    if (!productNode) continue;
    fragment.appendChild(productNode);
  }

  productQueue.forEach((node) => fragment.appendChild(node));

  grid.innerHTML = '';
  grid.appendChild(fragment);
}

function createBrandCornerCard(campaign, campaignContent, card, width, height) {
  const cardMediaWrapper = document.createElement('div');
  cardMediaWrapper.classList.add('card-product__image-wrapper');
  cardMediaWrapper.style.padding = '0';
  cardMediaWrapper.style.height = '100%';
  const cardMedia = document.createElement('div');
  cardMedia.classList.add('card-product__media');
  cardMediaWrapper.dataset.bannerPromo = 'banner';
  cardMediaWrapper.dataset.bannerId = campaign.flightId || 'none';
  cardMediaWrapper.dataset.bannerName = campaignContent.data.ctcampaignName || 'none';
  cardMediaWrapper.dataset.creativeSlot = campaignContent.data.ctcreativeSlot || 'none';
  cardMediaWrapper.dataset.itemId = campaignContent.data.ctid || 'none';
  cardMediaWrapper.dataset.bannerIndex = 0 || campaign.flightId;
  cardMediaWrapper.dataset.bannerImg = `https://s.zkcdn.net/Advertisers/${campaignContent.data.ctDesktopImage}`;

  const link = document.createElement('a');
  link.href = campaign.clickUrl;
  const principalImage = document.createElement('img');
  principalImage.style.objectFit = 'cover';
  principalImage.style.width = '100%';
  principalImage.style.height = '100%';
  principalImage.classList.add('card-product__media--principal');
  principalImage.loading = 'lazy';
  principalImage.alt = campaignContent.data.ctcreativeSlot;
  principalImage.src = `https://s.zkcdn.net/Advertisers/${campaignContent.data.ctDesktopImage}`;
  principalImage.width = campaignContent.data.width;
  principalImage.height = campaignContent.data.height;
  link.appendChild(principalImage);

  card.textContent = '';
  cardMediaWrapper.appendChild(link);
  card.appendChild(cardMediaWrapper);
  card.appendChild(
    new SponsoredSlideFooter({
      advertiserName: campaignContent.data.ctadvertiserName || 'Anonymous',
      paidForBy: campaignContent.data.ctpaidForBy || 'Anonymous',
    }).create()
  );
  card.style.minWidth = `${width}px`;
  card.style.minHeight = `${height}px`;
  card.classList.add('kevel-image-banner');
  card.classList.add('kevel-loaded');
  card.classList.remove('animated');

  fdKevel.sendViewableImpression(card, campaign);
}
